var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabelsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4732 14.415L20.4732 8.41505C20.5553 8.29185 20.5992 8.14709 20.5992 7.99902C20.5992 7.85095 20.5553 7.7062 20.4732 7.583L16.4732 1.583C16.4047 1.48026 16.3119 1.39603 16.2031 1.33777C16.0942 1.27951 15.9726 1.24902 15.8492 1.24902H1.25055L5.47322 7.58377C5.55535 7.70697 5.59917 7.85173 5.59916 7.9998C5.59915 8.14787 5.55532 8.29262 5.47318 8.41582L1.25055 14.749H15.8492C15.9726 14.749 16.0942 14.7185 16.2031 14.6603C16.3119 14.602 16.4047 14.5178 16.4732 14.415Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelsIcon);
export default __webpack_public_path__ + "static/media/labels-icon.57a71634.svg";
export { ForwardRef as ReactComponent };